import { render, staticRenderFns } from "./SuccessfulPurchase.vue?vue&type=template&id=8918c6da&scoped=true"
import script from "./SuccessfulPurchase.vue?vue&type=script&lang=js"
export * from "./SuccessfulPurchase.vue?vue&type=script&lang=js"
import style0 from "./SuccessfulPurchase.vue?vue&type=style&index=0&id=8918c6da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8918c6da",
  null
  
)

export default component.exports